import tw, { styled } from 'twin.macro';

const AppContainer = styled.div`
  ${tw`min-h-screen flex flex-col w-full h-screen overflow-y-auto`}
  margin-inline-start: 0;
  box-sizing: border-box;
  flex: 1 1 100%;
`;

export default AppContainer;
